export default __webpack_public_path__ + "static/char-thumb-20-a3bfb5b8038401f59eac5d48f6b1fb3c.png";